import type { ReactNode } from "react";

import { cn } from "../../lib/utils";

export function PageHeader({
  actions,
  children,
  className,
  description,
  descriptionClassName,
  title,
  titleClassName,
}: {
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  description?: ReactNode;
  descriptionClassName?: string;
  title: ReactNode;
  titleClassName?: string;
}) {
  return (
    <header
      className={cn(
        "flex flex-wrap items-start justify-between gap-4",
        className,
      )}
      data-slot="page-header"
    >
      <div className="min-w-0 max-w-3xl space-y-2">
        <h1 className={cn("headline-2 text-foreground", titleClassName)}>
          {title}
        </h1>
        {description ? (
          <p
            className={cn(
              "body-muted max-w-3xl leading-6",
              descriptionClassName,
            )}
          >
            {description}
          </p>
        ) : null}
        {children}
      </div>
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2 sm:self-center">
          {actions}
        </div>
      ) : null}
    </header>
  );
}
